<div class="flex flex-col items-center space-y-5" id="donut-chart__container">
  <canvas id="canvas-donut-chart">{{ chart }}</canvas>
</div>
<div class="flex flex-col items-start space-y-2 mt-[1rem]">
  @for(item of config?.labels; track item; let idx = $index) {
  <div class="flex items-center space-x-2" id="{{ 'donut-chart__item' + idx }}">
    <div
      class="w-4 h-4 rounded-md"
      [style.backgroundColor]="config?.colors?.[idx] || ''"
    ></div>
    <span class="font-[1rem] font-bold text-grayscale-heavy">{{
      item | transloco
    }}</span>
  </div>
  }
</div>
